export class ItemFilter {
    public like?: string;
    public equal?: string[];
}
